// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var CaseRoleType;
(function (CaseRoleType) {
    CaseRoleType[CaseRoleType["Unknown"] = 0] = "Unknown";
    CaseRoleType[CaseRoleType["Patient"] = 1] = "Patient";
    CaseRoleType[CaseRoleType["Prescriber"] = 2] = "Prescriber";
    CaseRoleType[CaseRoleType["InsuranceProvider"] = 3] = "InsuranceProvider";
    CaseRoleType[CaseRoleType["PharmacyBenefitManager"] = 4] = "PharmacyBenefitManager";
    CaseRoleType[CaseRoleType["SecondaryContact"] = 5] = "SecondaryContact";
    CaseRoleType[CaseRoleType["Manufacturer"] = 6] = "Manufacturer";
    CaseRoleType[CaseRoleType["EMP"] = 7] = "EMP";
    CaseRoleType[CaseRoleType["CustomerServiceRep"] = 8] = "CustomerServiceRep";
    CaseRoleType[CaseRoleType["PrescriberSite"] = 9] = "PrescriberSite";
    CaseRoleType[CaseRoleType["Brand"] = 10] = "Brand";
    CaseRoleType[CaseRoleType["Child"] = 11] = "Child";
    CaseRoleType[CaseRoleType["SocialWorker"] = 12] = "SocialWorker";
    CaseRoleType[CaseRoleType["FinancialRepresentative"] = 13] = "FinancialRepresentative";
    CaseRoleType[CaseRoleType["LegalRepresentative"] = 14] = "LegalRepresentative";
    CaseRoleType[CaseRoleType["Corporate"] = 15] = "Corporate";
    CaseRoleType[CaseRoleType["PersonalContact"] = 16] = "PersonalContact";
    CaseRoleType[CaseRoleType["Spouse"] = 17] = "Spouse";
    CaseRoleType[CaseRoleType["Parent"] = 18] = "Parent";
    CaseRoleType[CaseRoleType["HomeHealth"] = 19] = "HomeHealth";
    CaseRoleType[CaseRoleType["AlternateContact"] = 20] = "AlternateContact";
    CaseRoleType[CaseRoleType["AutoInjuryPlan"] = 21] = "AutoInjuryPlan";
    CaseRoleType[CaseRoleType["CommercialPlan"] = 22] = "CommercialPlan";
    CaseRoleType[CaseRoleType["FederalEmployeeProgram"] = 23] = "FederalEmployeeProgram";
    CaseRoleType[CaseRoleType["Medicaid"] = 24] = "Medicaid";
    CaseRoleType[CaseRoleType["MedicareAdvantage"] = 25] = "MedicareAdvantage";
    CaseRoleType[CaseRoleType["MedicareB"] = 26] = "MedicareB";
    CaseRoleType[CaseRoleType["MedicareD"] = 27] = "MedicareD";
    CaseRoleType[CaseRoleType["MediGap"] = 28] = "MediGap";
    CaseRoleType[CaseRoleType["VADoDTRICARE"] = 29] = "VADoDTRICARE";
    CaseRoleType[CaseRoleType["WorkersCompensation"] = 30] = "WorkersCompensation";
    CaseRoleType[CaseRoleType["Plan"] = 31] = "Plan";
    CaseRoleType[CaseRoleType["Payer"] = 32] = "Payer";
    CaseRoleType[CaseRoleType["DurableMedicalEquiqmentPlan"] = 33] = "DurableMedicalEquiqmentPlan";
    CaseRoleType[CaseRoleType["ManagedCareMedicaidPlan"] = 34] = "ManagedCareMedicaidPlan";
    CaseRoleType[CaseRoleType["StatePharmacyAssistanceProgram"] = 35] = "StatePharmacyAssistanceProgram";
    CaseRoleType[CaseRoleType["MedicarePartABPlan"] = 36] = "MedicarePartABPlan";
    CaseRoleType[CaseRoleType["AidsDrugAssistanceProgram"] = 37] = "AidsDrugAssistanceProgram";
    CaseRoleType[CaseRoleType["StatePlan"] = 38] = "StatePlan";
    CaseRoleType[CaseRoleType["Provider"] = 39] = "Provider";
    CaseRoleType[CaseRoleType["ExclusiveProviderOrganization"] = 40] = "ExclusiveProviderOrganization";
    CaseRoleType[CaseRoleType["IndemnityInsurance"] = 41] = "IndemnityInsurance";
    CaseRoleType[CaseRoleType["HealthMaintenanceOrganization"] = 42] = "HealthMaintenanceOrganization";
    CaseRoleType[CaseRoleType["PointOfServicePlan"] = 43] = "PointOfServicePlan";
    CaseRoleType[CaseRoleType["PreferredProviderOrganization"] = 44] = "PreferredProviderOrganization";
    CaseRoleType[CaseRoleType["Self"] = 45] = "Self";
    CaseRoleType[CaseRoleType["OfficeContact"] = 46] = "OfficeContact";
    CaseRoleType[CaseRoleType["Pharmacy"] = 47] = "Pharmacy";
    CaseRoleType[CaseRoleType["MedicareA"] = 48] = "MedicareA";
    CaseRoleType[CaseRoleType["Hospital"] = 49] = "Hospital";
    CaseRoleType[CaseRoleType["HospitalOutpatient"] = 50] = "HospitalOutpatient";
    CaseRoleType[CaseRoleType["InfusionCenter"] = 51] = "InfusionCenter";
    CaseRoleType[CaseRoleType["RetailPharmacy"] = 52] = "RetailPharmacy";
    CaseRoleType[CaseRoleType["Foundation"] = 53] = "Foundation";
    CaseRoleType[CaseRoleType["SecondarySupplemental"] = 54] = "SecondarySupplemental";
    CaseRoleType[CaseRoleType["RegisteredNurse"] = 55] = "RegisteredNurse";
    CaseRoleType[CaseRoleType["LicensedPracticalNurse"] = 56] = "LicensedPracticalNurse";
    CaseRoleType[CaseRoleType["CertifiedNursingAssistant"] = 57] = "CertifiedNursingAssistant";
    CaseRoleType[CaseRoleType["MedicalAssistant"] = 58] = "MedicalAssistant";
    CaseRoleType[CaseRoleType["NationalHomeHealthAgency"] = 59] = "NationalHomeHealthAgency";
    CaseRoleType[CaseRoleType["IndependentHomeHealthAgency"] = 60] = "IndependentHomeHealthAgency";
    CaseRoleType[CaseRoleType["Practice"] = 61] = "Practice";
    CaseRoleType[CaseRoleType["PerDiemContractIndividual"] = 62] = "PerDiemContractIndividual";
    CaseRoleType[CaseRoleType["Employee"] = 63] = "Employee";
})(CaseRoleType || (CaseRoleType = {}));
//# sourceMappingURL=caseRoleType.js.map